// Per-job request bounds of the generation services, and the helpers the runners
// and useToolsRunner share to stay inside them (spec 2026-10-07, 0.4 "Live 422
// fixes"). A request above a bound is split into several jobs, never sent whole:
// the service would reject it with 422.

// ibm-materials-service PolymerGenerateIn.num_samples: Field(ge=1, le=1000).
export const FM4M_MAX_SAMPLES_PER_JOB = 1000;
// gt4sd-service GenerateRequest.n_samples: Field(ge=1, le=200).
export const GT4SD_MAX_SAMPLES_PER_JOB = 200;

/** Split `total` into job sizes of at most `perJobMax`: full jobs, then one
 * remainder job. A non-positive or non-numeric request is no jobs. */
export function splitJobs(total, perJobMax) {
  const n = Math.floor(Number(total));
  const per = Math.floor(Number(perJobMax));
  if (!Number.isFinite(n) || n < 1 || !Number.isFinite(per) || per < 1) return [];
  const sizes = [];
  for (let left = n; left > 0; left -= per) sizes.push(Math.min(per, left));
  return sizes;
}

/** The oversample multiplier an FM4M generation job runs with. Without filters
 * the worker generates exactly num_samples (models/ibm-materials-service/main.py
 * routes filterless jobs to _execute_polymer_generate), so it is 1. With filters
 * it over-generates num_samples x multiplier: default 3, service bound 1 to 10.
 * The run-total charge (R4-2) uses this same number. */
export function fm4mOversample(fm4mOptions) {
  const opts = fm4mOptions || {};
  const hasFilters = !!opts.filters && Object.keys(opts.filters).length > 0;
  if (!hasFilters) return 1;
  const m = Math.floor(Number(opts.oversample_multiplier) || 3);
  return Math.min(10, Math.max(1, m));
}

/** The seed SMILES an FM4M call featurizes instead of generating. Non-empty means
 * the call is representation only (FM4MRunner skips generation). */
export function fm4mSeedSmiles(meta) {
  const m = meta || {};
  if (Array.isArray(m.seed_smiles)) return m.seed_smiles.filter((s) => typeof s === 'string' && s.trim());
  if (typeof m.seed_smiles === 'string') return [m.seed_smiles];
  if (Array.isArray(m.smiles)) return m.smiles.filter((s) => typeof s === 'string' && s.trim());
  if (typeof m.smiles === 'string') return [m.smiles];
  return [];
}
